import request from "@/config/utils/request";

export function getAppRole(data) {
  return request({
    url: "/apis/demo/role/listRoles", // 请求角色列表 联调入参 { "applicationId":106}  值106是组织管理
    method: "post",
    data
  });
}

export function saveRoleInfo(data) {
  return request({
    url: "/apis/demo/role/saveRoleInfo", // 新建角色
    method: "post",
    data
  });
}

// 角色中用户
export function saveUserList(data) {
  return request({
    url: "/apis/demo/role/saveUserList", // 新建角色中的成员[{userList autoCode}]
    method: "post",
    timeout: 30 * 1000,
    data
  });
}

export function removeUser(data) {
  return request({
    url: "/apis/demo/role/removeUser", // 角色用户列表 删除用户{userRoleList:[],roleId:2}
    method: "post",
    timeout: 30 * 1000,
    data
  });
}

export function getUserList(data) {
  return request({
    url: "/apis/demo/role/listUsers", // 角色用户列表 {roleId}
    method: "post",
    data
  });
}

export function getRoleMenu(data) {
  return request({
    url: "/apis/demo/role/listRoleMenu", // 获取角色的菜单 {roleId}
    method: "post",
    data
  });
}

export function editRoleMenu(data) {
  return request({
    url: "/apis/demo/role/editRoleMenu", // 更新角色的菜单 {roleId resourceIds}
    method: "post",
    timeout: 30 * 1000,
    data
  });
}

// 编辑角色接口
export function editRoleInfo(data) {
  return request({
    url: "/apis/demo/role/editRoleInfo", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}

export function removeRole(data) {
  return request({
    url: "/apis/demo/role/removeRole",
    method: "post",
    data,
    timeout: 30 * 1000
  });
}

export function getRoleInfo(data) {
  return request({
    url: "/apis/demo/role/listThisRole", // 通过id查询角色名称 {roleId}
    method: "post",
    data
  });
}
